import post from './post'
import update from './update'

export default {
  post,
  update
}
